import { todayUtcKey } from '@/utils/format';

/**
 * LR-544: is a position's Trade Date still in the future?
 *
 * `trade_date` is a datetime ISO string; we compare its UTC calendar day against
 * UTC "today" so the FE gate agrees with the backend, which rejects a future-TD
 * open in UTC. Single source of truth for the button-disable reason
 * (TradeDetailPage), the modal Confirm guard (ProcessTradeDateModal) and the
 * pending-banner copy (TradePendingBanner).
 */
export function isTradeDateInFuture(tradeDate: string | null | undefined): boolean {
  return (tradeDate?.slice(0, 10) ?? '') > todayUtcKey();
}
